import {
    AUTH_TOKEN,
    AUTHENTICATED,
    SHOW_AUTH_MESSAGE,
    HIDE_AUTH_MESSAGE,
    SIGNUP_SUCCESS,
    SHOW_LOADING,
    SIGNOUT,
    SIGNIN,
    USER_ROLE,
    NUMER_PRACOWNIKA
} from "../constants/Auth";

const initState = {
    loading: false,
    message: "",
    showMessage: false,
    redirect: "",
    token: localStorage.getItem(AUTH_TOKEN),
    role: localStorage.getItem(USER_ROLE),
    numer_pracownika: localStorage.getItem(NUMER_PRACOWNIKA),
};

const auth = (state = initState, action) => {
    switch (action.type) {
        case SIGNIN:
        case AUTHENTICATED:
            return {
                ...state,
                loading: false,
                redirect: "/",
                token: action.token,
                role: action.role,
                numer_pracownika: action.numer_pracownika
            };
        case SHOW_AUTH_MESSAGE:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false,
            };
        case HIDE_AUTH_MESSAGE:
            return {
                ...state,
                message: "",
                showMessage: false,
            };
        case SIGNOUT: {
            return {
                ...state,
                token: null,
                redirect: "/",
                loading: false,
            };
        }
        case SIGNUP_SUCCESS: {
            return {
                ...state,
                loading: false,
                token: action.token,
            };
        }
        case SHOW_LOADING: {
            return {
                ...state,
                loading: true,
            };
        }
        default:
            return state;
    }
};

export default auth;
